import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MaintenanceComponent } from './maintenance.component';
import { environment } from '@env/environment';
import { extract } from '@app/services/i18n/i18n.service';

const routes: Routes = [
  {
    path: '',
    component: MaintenanceComponent,
    data: { title: extract(`${environment.product_name} :: Maintenance`) },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class MaintenanceRoutingModule {}
